import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=29d9aeea&scoped=true"
import script from "./TemplateItem.vue?vue&type=script&lang=js"
export * from "./TemplateItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=29d9aeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d9aeea",
  null
  
)

export default component.exports